







helpers = require('../../../helpers.coffee')

view_model = {
    components:
      accountStatusInfo: require('../account_status_info')

    data: ->
      account_status: Session.current_user.email_account_status
      show_alert: false
      nylas_setting: Session.current_user.nylas_setting

    methods:
      emitOpenCompose: ->
        event.originalEventName = 'Compose::Open'
        EventsBus.$emit 'Compose::Open', { event }

      setRunningStatus: ->
        @updateAccountStatus('running')
        @show_alert = @updateShowAlert()

      updateAccountStatus: (account_status) ->
        Session.current_user.email_account_status = account_status
        @account_status = account_status
        @current_user = Session.current_user

      updateShowAlert: ->
        return false unless @current_user?.email_account_status
        @show_account_status || @show_nylas_setting

      subscribeToChannel: ->
        @removeSubscription()
        return if !@current_user
        @subscription = ActionCable.cable.subscriptions.create { channel: 'NylasAccountStatusUpdatedChannel', user_id: @current_user.id },
          received: (nylas_setting) =>
            @updateAccountStatus(nylas_setting.account_status)
            @nylas_setting = nylas_setting
            @show_alert = @updateShowAlert()

      removeSubscription: ->
        ActionCable.cable.subscriptions.remove(@subscription) if @subscription
        @subscription = null

    computed:
      show_account_status: ->
        @current_user?.email_service_requires_authorization && @current_user?.email_account_status != 'running'

      show_nylas_setting: ->
        @nylas_setting?.quota_exceeded != null

    created: ->
      @current_user = Session.current_user
      @show_alert = @updateShowAlert()
      EventsBus.$on 'email-account-connected', @setRunningStatus

    mounted: ->
      @subscribeToChannel() if @current_user?.email_service_requires_authorization

    beforeDestroy: ->
      @removeSubscription()
}

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/header_actions/email.vue